﻿$.fn.dxCtrlBuilderEmailSaisieTexte = function custom_dxCtrlBuilderEmailSaisieTexte(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailsaisietexte dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailSaisieTexte(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailSaisieTexte = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        $("<div/>").appendTo(container).dxCtrlTxtEmoji({
            bddCtrl: bddRef,
            pickerPosition: "bottom",
            value: oldTxt,
            placeholder: option.placeholder,
            onValueChanged: function (value) {
                option.onValueChanged(value)
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")
    }

    this.element = function () { return container }

    mConstruit();
}